/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{background:#fff;box-sizing:border-box;display:flex;min-height:240px;min-width:240px;padding:42px 54px;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}.no-padding[_nghost-%COMP%]{padding:0}[_nghost-%COMP%]     .ui-dialog-close{cursor:pointer;fill:#636f79;height:20px;padding:4px;position:absolute;right:46px;top:40px;width:20px;z-index:100}[_nghost-%COMP%]     .ui-dialog-close:hover{fill:#424650}[_nghost-%COMP%]     h3{align-self:flex-start;font-size:28px;font-weight:400;margin:0;padding:0}"];
export { styles as styles };
